import { useEffect, useState } from 'react';

const testimonials = [
  {
    quote: '„Web bol online za 4 dni. Iné agentúry mi hovorili 6–8 týždňov."',
    name: 'Marek Horváth',
    role: 'majiteľ e-shopu',
    seq: 41,
  },
  {
    quote: '„Do mesiaca sme mali prvé objednávky cez nový web. Neuveriteľná rýchlosť."',
    name: 'Zuzana Blaho',
    role: 'kozmetická klinika',
    seq: 42,
  },
  {
    quote: '„Konečne web ktorý naozaj predáva. A bol hotový skôr ako som čakal."',
    name: 'Peter Kováč',
    role: 'fitness tréner',
    seq: 43,
  },
];

export default function HeroFloatingCards() {
  const [testimonialIdx, setTestimonialIdx] = useState(0);
  const [delivered, setDelivered] = useState(false);

  useEffect(() => {
    const deliveredTimer = setTimeout(() => setDelivered(true), 2200);

    const testimonialInterval = setInterval(() => {
      setTestimonialIdx((t) => (t + 1) % testimonials.length);
    }, 4000);

    return () => {
      clearTimeout(deliveredTimer);
      clearInterval(testimonialInterval);
    };
  }, []);

  const current = testimonials[testimonialIdx];

  return (
    <div className="w-full select-none space-y-3">

      {/* ── WEBSITE MOCKUP CARD ── */}
      <div className="relative bg-zinc-900/90 border border-zinc-800 rounded-2xl overflow-hidden">
        {/* Browser bar */}
        <div className="flex items-center gap-2 px-4 py-3 border-b border-zinc-800/80 bg-zinc-900">
          <div className="flex gap-1.5">
            <div className="w-3 h-3 rounded-full bg-zinc-700" />
            <div className="w-3 h-3 rounded-full bg-zinc-700" />
            <div className="w-3 h-3 rounded-full bg-zinc-700" />
          </div>
          <div className="flex-1 mx-3 bg-zinc-800 rounded-full px-3 py-1 flex items-center gap-2">
            <i className="ri-lock-2-line text-emerald-400 text-xs" />
            <span className="text-zinc-500 text-xs">vasafirma.sk</span>
          </div>
          {delivered && (
            <div className="flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/25 rounded-full px-2.5 py-1">
              <i className="ri-check-line text-emerald-400 text-xs" />
              <span className="text-emerald-400 text-xs font-bold">LIVE</span>
            </div>
          )}
        </div>

        {/* Mock website content */}
        <div className="relative px-4 py-4 overflow-hidden" style={{ height: '168px' }}>
          {/* Nav mock */}
          <div className="flex items-center justify-between mb-3">
            <div className="w-16 h-3 bg-orange-500/40 rounded-full" />
            <div className="flex gap-2">
              {[40, 30, 35, 28].map((w, i) => (
                <div key={i} className="h-2.5 bg-zinc-700/70 rounded-full" style={{ width: `${w}px` }} />
              ))}
            </div>
            <div className="w-20 h-7 bg-orange-500/30 border border-orange-500/25 rounded-lg" />
          </div>

          {/* Hero mock */}
          <div className="flex gap-4 mb-3">
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-zinc-100/8 rounded w-4/5" />
              <div className="h-4 bg-zinc-100/8 rounded w-3/5" />
              <div className="h-3 bg-zinc-700/50 rounded w-full mt-3" />
              <div className="h-3 bg-zinc-700/50 rounded w-5/6" />
              <div className="mt-3 w-28 h-8 bg-gradient-to-r from-orange-500/60 to-amber-500/60 rounded-lg" />
            </div>
            <div className="w-28 h-24 bg-zinc-800 rounded-xl overflow-hidden flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20clean%20website%20landing%20page%20hero%20section%20mockup%20on%20laptop%20screen%20professional%20business%20design%20orange%20accent%20color%20dark%20theme%20minimal&width=200&height=150&seq=webmock11&orientation=landscape"
                alt="web ukážka"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Sections mock */}
          <div className="grid grid-cols-3 gap-2">
            {[1, 2, 3].map((i) => (
              <div key={i} className="h-6 bg-zinc-800/60 rounded-lg" />
            ))}
          </div>

          {/* Delivered overlay */}
          <div
            className="absolute inset-0 flex items-center justify-center pointer-events-none transition-opacity duration-700"
            style={{ opacity: delivered ? 1 : 0 }}
          >
            <div className="absolute inset-0 bg-zinc-950/55" />
            <div className="relative flex flex-col items-center gap-2">
              <div className="w-14 h-14 rounded-full bg-emerald-500/20 border-2 border-emerald-500/50 flex items-center justify-center">
                <i className="ri-check-double-line text-emerald-400 text-2xl" />
              </div>
              <span className="text-white font-black text-lg tracking-wide">Odovzdané!</span>
              <span className="text-zinc-400 text-xs">Deň 5 - web je live</span>
            </div>
          </div>
        </div>
      </div>

      {/* ── TESTIMONIAL ── */}
      <div className="bg-zinc-900/80 border border-zinc-800 rounded-2xl px-5 py-4">
        <div className="relative overflow-hidden" style={{ minHeight: '72px' }}>
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="transition-all duration-500"
              style={{
                opacity: i === testimonialIdx ? 1 : 0,
                position: i === testimonialIdx ? 'relative' : 'absolute',
                inset: i === testimonialIdx ? 'auto' : '0',
                transform: i === testimonialIdx ? 'translateY(0)' : 'translateY(6px)',
              }}
            >
              <p className="text-zinc-300 text-sm leading-snug mb-3 italic">{t.quote}</p>
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full overflow-hidden border border-zinc-700 flex-shrink-0">
                  <img
                    src={`https://readdy.ai/api/search-image?query=smiling%20professional%20portrait%20headshot%20clean%20white%20background%20business%20casual%20warm%20friendly%20face&width=60&height=60&seq=htesti${t.seq}&orientation=squarish`}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="text-white text-xs font-bold">{t.name}</p>
                  <p className="text-zinc-500 text-[10px]">{t.role}</p>
                </div>
                <div className="ml-auto flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <i key={s} className="ri-star-fill text-orange-400 text-xs" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-1.5 mt-3">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setTestimonialIdx(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer ${i === testimonialIdx ? 'w-4 h-1.5 bg-orange-500' : 'w-1.5 h-1.5 bg-zinc-700'}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
